(() => {
  document.addEventListener('click', (event) => {
    const closeBtn = event.target.closest('.close-btn');
    if (!closeBtn) return;

    event.preventDefault();

    const collectionSidebar = closeBtn.closest('[data-collection-sidebar]');
    if (!collectionSidebar) return;

    const groupTagsButton = document.querySelector('[data-aria-toggle][aria-controls="' + collectionSidebar.id + '"]');
    const collectionSidebarSlider = collectionSidebar.querySelector('[data-collection-sidebar-slider]');
    const collectionSidebarSlideOut = collectionSidebar.querySelector('[data-collection-sidebar-slide-out]');
    const collectionSidebarScrollable = collectionSidebarSlider || collectionSidebarSlideOut;

    if (groupTagsButton) {
      groupTagsButton.setAttribute('aria-expanded', 'false');
    }

    collectionSidebar.classList.add('expanding');
    collectionSidebar.classList.remove('expanded');

    if (collectionSidebarScrollable) {
      collectionSidebarScrollable.classList.remove('expanded');
    }

    const openPopouts = collectionSidebar.querySelectorAll('.popout--group[aria-expanded="true"]');
    openPopouts.forEach((item) => {
      item.setAttribute('aria-expanded', 'false');
    });

    setTimeout(() => {
      collectionSidebar.classList.remove('expanding');
    }, 500);

    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  });
})();